module.exports = __webpack_public_path__ + "static/media/attachment.66f99cdb.svg";